export default __webpack_public_path__ + "static/media/no_problem.2320f672.svg";